var $ = require('jquery');
var _ = require('underscore');
var Validation = require('validation');

var reset = function () {
    this.model.isValid(this.attribute);
};

var invalid = function (view, attr, error, selector) {
    var Labels = EY.Consultation.Labels;
    var $default = view.$("[" + selector + "=" + attr + "]");
    var isValidationWraps =  $('.validation-wrap-cpp:first').length > 0 || $('.validation-wrap-rpp:first').length > 0;
    isValidationWraps && $('.validation-wrap-main').length === 0 && $('.validation-wrap-cpp:first,.validation-wrap-rpp,.validation-wrap-rn').wrapAll('<div class="validation-wrap-main"></div>');
    if (isValidationWraps && view.model.get('approverGroupId') === 'RequiredNotification' && attr != 'rank') {
        $default = $('.validation-wrap-main');
        error = Labels.RnValidationMsg;
    }
    var compile = _.template($("#validationErrorTemplate").html());
    var compiled = $(compile({ msg: error }));
    var event = 'change:' + attr;
    var model = view.model;
    var options = {
        attribute: attr,
        model: view.model
    };

    $default.find('~ .required-errmsg').remove();
    $default.addClass('required').parents('.collapse').collapse('show').prev().find('.error-group').addClass('fa fa-exclamation-triangle');

    compiled.insertAfter($default);
    model.off(event, reset).on(event, reset, options);
};

var valid = function (view, attr, selector) {
    var $default = view.$("[" + selector + "=" + attr + "]");
    var isValidationWraps =  $('.validation-wrap-cpp:first').length > 0 || $('.validation-wrap-rpp:first').length > 0;
    var hasValidationWraps = view.$el.hasClass('validation-wrap-rn') || view.$el.hasClass('validation-wrap-cpp') || view.$el.hasClass('validation-wrap-rpp');
    if (isValidationWraps && hasValidationWraps) {
        $default.removeClass('required').find('~ .required-errmsg').remove();
        $default = $('.validation-wrap-main');
    }
    var event = 'change:' + attr;
    var model = view.model;

    $default.removeClass('required').find('~ .required-errmsg').remove();
    model.off(event, reset);
};

module.exports.configure = function () {
    _.extend(Backbone.Model.prototype, Backbone.Validation.mixin);
    _.extend(Validation.callbacks, {
        invalid: invalid,
        valid: valid
    });
};



// WEBPACK FOOTER //
// ./js/Modules/Service/Validation.js